import { usePage } from '@inertiajs/react'
import { Navbar, NavbarSpacer, NavbarSection } from '@/components/ui'
import { Logo } from '@/components/brand/Logo'
import type { SharedProps } from '@/types'

/**
 * Mobile top bar (shown by SidebarLayout below `lg`). The sidebar menu button
 * sits to its left; we fill the rest with the brand logo (blue, on white).
 */
export function AppNavbar() {
  const { props } = usePage<SharedProps>()
  return (
    <Navbar>
      <NavbarSpacer />
      <NavbarSection>
        <Logo variant="blue" src={props.branding.logo_blue} className="h-7" alt={props.branding.brand_name} />
      </NavbarSection>
    </Navbar>
  )
}
